module.exports = __webpack_public_path__ + "img/smileys.296d4dc7.svg";